import React from 'react'
import { Menu, MenuItem } from '@blueprintjs/core'

export const DocumentTagAdditionPopover = ({ tags, tagOnClick }) => {
    const activeTags = tags.filter(t => t.is_active)
    const popoverItemStyle = { fontWeight: '600', textAlign: 'center', borderRadius: '50px' }
    return <>
      <div>
        <Menu>
          {activeTags.map((t, idx) => <MenuItem
            text={t.name}
            style={popoverItemStyle}
            onClick={(e) => {
              e.stopPropagation()
              tagOnClick(t.id)
            }}
            key={idx}
          />)}
          {!activeTags?.length && <MenuItem
            text='No Available Tags'
            style={popoverItemStyle}
            onClick={(e) => {
              e.stopPropagation()
            }}
            key={'no-avail-tags-item'}
          />}
        </Menu>
      </div>
    </>
  }